export const tenantsForCustomUi = {
  glsAt: 'gls-at',
  glsDe: 'gls-de',
  glsHu: 'gls-hu',
  glsIt: 'gls-it',
  royalMailUK: 'royalmail-uk',
  royalMailUKTest: 'royalmail-uk-test'
};
